/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgComputerStats = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 21H2v-2h20zM13.371 9.59l1.86-2.23 1.538 1.28-3.141 3.768-2.941-2.45-1.874 2.623-1.626-1.162 3.125-4.377z" />
        <path d="M20 17H4V3h16zM6 15h12V5H6z" />
      </g>
    </g>
  </Icon>
);
export { SvgComputerStats as ComputerStats };
